import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';

const Terms = () => {
    const { t } = useTranslation();

    return (
        <div className="page-wrapper">
            <header className="header header-fixed">
                <div className="container">
                    <div className="header-content">
                        <div className="left-content">
                            <Link to="/welcome" className="back-btn">
                                <ChevronLeft className="icon" />
                            </Link>
                            <h6 className="title">{t('terms.title')}</h6>
                        </div>
                    </div>
                </div>
            </header>

            <div className="page-content">
                <div className="container">
                    <div className="content-body">
                        <div className="terms-content">
                            <h2>{t('terms.title')}</h2>
                            
                            <section>
                                <h3>{t('terms.sections.acceptance.title')}</h3>
                                <p>{t('terms.sections.acceptance.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.eligibility.title')}</h3>
                                <p>{t('terms.sections.eligibility.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.userAccount.title')}</h3>
                                <p>{t('terms.sections.userAccount.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.userConduct.title')}</h3>
                                <p>{t('terms.sections.userConduct.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.subscriptions.title')}</h3>
                                <p>{t('terms.sections.subscriptions.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.termination.title')}</h3>
                                <p>{t('terms.sections.termination.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.disclaimer.title')}</h3>
                                <p>{t('terms.sections.disclaimer.content')}</p>
                            </section>

                            <section>
                                <h3>{t('terms.sections.contact.title')}</h3>
                                <p>{t('terms.sections.contact.content')}</p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terms;
